import React from 'react'

import { FlatMenu } from '../flat-menu'
import { Logo } from '@components/logo'

export const FlatHeader = () => {
  return (
    <div
      className="py-4 grid grid-cols-3 px-4 border-solid
    border-gray-200 border border-t-0 border-r-0 border-l-0 shadow-sm"
    >
      <div
        className="flex cursor-pointer col-start-2 justify-center"
        title="Portal Solar"
      >
        <Logo />
      </div>
      <FlatMenu />
    </div>
  )
}
